import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';

import NavbarData from './NavbarData';

const useStyles = makeStyles((theme) => ({
  link: {
    color: 'black',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.lifestyle.lightBlue,
    },
    textAlign: 'center',
  },
  menuItem: {
    fontSize: '0.9rem',
  },
}));

const LifestyleMenuContent = ({ handleClose, onNavigate }, ref) => {
  const classes = useStyles();
  return (
    <div>
      {NavbarData.LifestyleLinks.map((item, index) => {
        return (
          <a
            className={classes.link}
            href={item.link}
            key={index}
            onClick={() => handleClose()}
          >
            <MenuItem className={classes.menuItem} onClick={onNavigate}>
              {item.title}
            </MenuItem>
          </a>
        );
      })}
    </div>
  );
};

export default forwardRef(LifestyleMenuContent);
